import React, { Component, PropTypes } from 'react';
import IconSVG from 'svg-inline-react';
import isMobile from 'ismobilejs';
import Tip from 'components/TipControl'
import { createControlFactory } from 'components/Controls'
import { toMoneyFormat } from '../../../tools/number';
import ActionCreators from '../../actions/ActionCreators';

export class AdditionalServiceItem extends Component {
    static propTypes = {
        keyProp: PropTypes.string,
        iconKey: PropTypes.string,
        parameterService: PropTypes.object,
        selectedPartDayPrice: PropTypes.number,
        disabled: PropTypes.bool,
        onChangeService: PropTypes.func,
        iconSrc: PropTypes.object,
    }

    constructor(props) {
        super(props);

        this.Control = createControlFactory(ActionCreators.updateParameter)
    }

    render() {
        return (
            <div key={this.props.keyProp} className="Options-valueBar">
                <div className="Options-title">
                    <IconSVG
                        key={this.props.iconKey}
                        className='Parameter-Icon'
                        src={this.props.iconSrc}
                        title={this.props.parameterService.get('title')}/>

                    {this.props.parameterService.get('title')}

                    {!isMobile.phone &&
                        <Tip
                            className="Options-tipEscort"
                            label={this.props.parameterService.tip}
                        />
                    }
                </div>
                <div className="Options-value">
                    {this.props.parameterService.get('price_coef') ?
                        <div className="Options-valueLabel">
                            +{
                            toMoneyFormat(
                                Math.ceil((
                                    this.props.parameterService.get('price_coef') *
                                    this.props.selectedPartDayPrice) -
                                    this.props.selectedPartDayPrice
                                )
                            )
                        }₽
                        </div> :
                        <div className="Options-valueLabel">
                            +{toMoneyFormat(this.props.parameterService.get('price'))}₽
                        </div>
                    }
                    <div className="Options-wrapTip">
                        <this.Control
                            disabled={this.props.disabled}
                            type="checkbox"
                            label=""
                            attribute={this.props.parameterService}
                            onChange={this.props.onChangeService}/>

                        {this.props.disabled &&
                            <Tip
                                className="Options-innerTip"
                                label="Доступно только вместе с грузчиками"/>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./client/components/InstantBookingScreen/AdditionalServiceItem.js